import { KoobButton, KoobInputStepper, KoobPopover } from '@koob/ui';

// KD-3391: popover version of the experience-duration filter (replaces
// DurationButton + DurationModal); changes apply immediately.
const DurationPopover = ({ translation, value, onChange, max = 50 }) => {
  const minDuration = value?.min ?? 0;
  const maxDuration = value?.max;

  return (
    <KoobPopover
      trigger={
        <KoobButton variant="secondary" rounded="full">
          <i className="fa-light fa-alarm-clock text-gray-500" />
          <span>
            {maxDuration
              ? translation('search.expDurationRange', {
                  min: minDuration,
                  max: maxDuration,
                })
              : translation('search.expDuration')}
          </span>
          {maxDuration && (
            <i
              className="fa-regular fa-circle-xmark text-gray-500"
              onClick={(event) => {
                event.stopPropagation();
                onChange(null);
              }}
            />
          )}
        </KoobButton>
      }
    >
      <div className="space-y-4">
        <div className="space-y-1.5">
          <div className="text-sm font-medium text-gray-700">
            {translation('expDuration.minDuration')}
          </div>
          <KoobInputStepper
            value={minDuration}
            min={0}
            max={maxDuration ?? max}
            onValueChange={(newMin) =>
              onChange({ min: newMin, max: maxDuration ?? max })
            }
          />
        </div>

        <div className="space-y-1.5">
          <div className="text-sm font-medium text-gray-700">
            {translation('expDuration.maxDuration')}
          </div>
          <KoobInputStepper
            value={maxDuration ?? max}
            min={Math.max(minDuration, 1)}
            max={max}
            onValueChange={(newMax) =>
              onChange({ min: Math.min(minDuration, newMax), max: newMax })
            }
          />
        </div>
      </div>
    </KoobPopover>
  );
};

export default DurationPopover;
